import styles from './styles.module.css';

export const accordionItems = [
  {
    title: 'Vous souhaitez effectuer un versement sur votre livret ?',
    content: (
      <div className={styles.contentAccordion}>
        Les versements sur un livret ne se font pas par prélèvement mais par virement bancaire.
        <span> Le virement doit être effectué depuis le compte de confiance </span>
        (celui que vous avez déclaré à la souscription ou tout autre compte ayant été déclaré par la suite sur votre{' '}
        <a
          href="https://epargne.cfcal-banque.fr/auth/realms/fhome/protocol/openid-connect/auth?response_type=code&client_id=fhome-spa&state=dWg5SzNffkZFbUJhdEwxTlJhMFB2WnhSVlhaYkppaEJ3Mi1sNEw0MEFhbHZH&redirect_uri=https%3A%2F%2Fepargne.cfcal-banque.fr&scope=openid&code_challenge=5PDXrMgy3rDEOMKUbLERKdC0gFO4WezbFe4pQDIskd8&code_challenge_method=S256&nonce=dWg5SzNffkZFbUJhdEwxTlJhMFB2WnhSVlhaYkppaEJ3Mi1sNEw0MEFhbHZH"
          target="_blank"
          rel="noreferrer noopener"
        >
          {' '}
          espace client CFCAL
        </a>
        ). Dans le cas contraire le virement sera refusé.
        <br />
        <p>
          La consultation ou modification du compte de confiance s’effectue sur votre{' '}
          <a
            href="https://epargne.cfcal-banque.fr/auth/realms/fhome/protocol/openid-connect/auth?response_type=code&client_id=fhome-spa&state=dWg5SzNffkZFbUJhdEwxTlJhMFB2WnhSVlhaYkppaEJ3Mi1sNEw0MEFhbHZH&redirect_uri=https%3A%2F%2Fepargne.cfcal-banque.fr&scope=openid&code_challenge=5PDXrMgy3rDEOMKUbLERKdC0gFO4WezbFe4pQDIskd8&code_challenge_method=S256&nonce=dWg5SzNffkZFbUJhdEwxTlJhMFB2WnhSVlhaYkppaEJ3Mi1sNEw0MEFhbHZH"
            target="_blank"
            rel="noreferrer noopener"
          >
            {' '}
            espace client CFCAL
          </a>
          .
        </p>
        Les versements sont sans frais.
      </div>
    ),
  },
  {
    title: 'Vous souhaitez effectuer un retrait à partir de votre livret ?',
    content: (
      <div className={styles.contentAccordion}>
        <p>
          Pour réaliser un virement sur votre compte de confiance, il faut vous rendre sur votre{' '}
          <a
            href="https://epargne.cfcal-banque.fr/auth/realms/fhome/protocol/openid-connect/auth?response_type=code&client_id=fhome-spa&state=dWg5SzNffkZFbUJhdEwxTlJhMFB2WnhSVlhaYkppaEJ3Mi1sNEw0MEFhbHZH&redirect_uri=https%3A%2F%2Fepargne.cfcal-banque.fr&scope=openid&code_challenge=5PDXrMgy3rDEOMKUbLERKdC0gFO4WezbFe4pQDIskd8&code_challenge_method=S256&nonce=dWg5SzNffkZFbUJhdEwxTlJhMFB2WnhSVlhaYkppaEJ3Mi1sNEw0MEFhbHZH"
            target="_blank"
            rel="noreferrer noopener"
          >
            {' '}
            espace client CFCAL
          </a>
          .
        </p>
        Le plafond hebdomadaire de retrait est de 100 000€. Pour des raisons de sécurité, et dans le cadre de la lutte
        contre la fraude, tout retrait d&apos;un montant supérieur doit passer par une demande de déplafonnement à faire
        via la messagerie sécurisée de{' '}
        <a
          href="https://epargne.cfcal-banque.fr/auth/realms/fhome/protocol/openid-connect/auth?response_type=code&client_id=fhome-spa&state=dWg5SzNffkZFbUJhdEwxTlJhMFB2WnhSVlhaYkppaEJ3Mi1sNEw0MEFhbHZH&redirect_uri=https%3A%2F%2Fepargne.cfcal-banque.fr&scope=openid&code_challenge=5PDXrMgy3rDEOMKUbLERKdC0gFO4WezbFe4pQDIskd8&code_challenge_method=S256&nonce=dWg5SzNffkZFbUJhdEwxTlJhMFB2WnhSVlhaYkppaEJ3Mi1sNEw0MEFhbHZH"
          target="_blank"
          rel="noreferrer noopener"
        >
          {' '}
          l&apos;espace client CFCAL
        </a>
        , en précisant le montant souhaité et le motif du retrait (un justificatif pourra être demandé).
        <br />
        La demande est traitée en 1 jour ouvré, vous aurez ensuite 3 jours pour exécuter votre virement.
        <br />
        <p> Les retraits se font sans frais.</p>
      </div>
    ),
  },
  {
    title: 'Vous souhaitez effectuer une toute autre opération ?',
    content: (
      <div className={styles.contentAccordion}>
        Pour toute autre demande (changement de compte de confiance, clôture du livret etc...) il faut vous rendre sur{' '}
        <a
          href="https://epargne.cfcal-banque.fr/auth/realms/fhome/protocol/openid-connect/auth?response_type=code&client_id=fhome-spa&state=dWg5SzNffkZFbUJhdEwxTlJhMFB2WnhSVlhaYkppaEJ3Mi1sNEw0MEFhbHZH&redirect_uri=https%3A%2F%2Fepargne.cfcal-banque.fr&scope=openid&code_challenge=5PDXrMgy3rDEOMKUbLERKdC0gFO4WezbFe4pQDIskd8&code_challenge_method=S256&nonce=dWg5SzNffkZFbUJhdEwxTlJhMFB2WnhSVlhaYkppaEJ3Mi1sNEw0MEFhbHZH"
          target="_blank"
          rel="noreferrer noopener"
        >
          {' '}
          l&apos;espace client CFCAL
        </a>
        .
      </div>
    ),
  },
];
